// Libs & Frameworks
import styled from "styled-components";

// Components
import Website from "./components/Wesbite";

// Style
const Parent = styled.div`
  text-align: center;
`;

// JSX
function App() {
  return (
    <Parent>
      <Website />
    </Parent>
  );
}

export default App;
